import fetchFamilies from '../../../services/api/family/initFamilies'

/**
 * @description
 * Store any data procesing for store here, to avoid bloating other module files
 * @param {*} someParam
 */
const initFamilies = async () => {
    return await fetchFamilies()
}

export { initFamilies }
